import { createContext, useContext } from 'react'
import { TenantConfig } from '@app/types/TenantConfig'
import crowdbuildingConfig from '@app/tenantConfig'
import { ViewTenantModel } from 'functions/tenant/steunpunt-amsterdam/view'

export interface TenantContextType extends TenantConfig {
  tenant?: ViewTenantModel
  loading?: boolean
}

export const TenantContext =
  createContext<TenantContextType>(crowdbuildingConfig)

export const useTenantContext = () => useContext(TenantContext)
